export default __webpack_public_path__ + "static/planet_coming_soon-1cb2b6c0a0378e96adc05a9910d2b3eb.jpg";